import { DANCE_STYLE } from "../enum";

const danceStyleOptions = [DANCE_STYLE.ZUMBA, DANCE_STYLE.AEROBIC, DANCE_STYLE.HIPHOP, DANCE_STYLE.JAZZ, DANCE_STYLE.MODERN, DANCE_STYLE.NON_PREFERENCE];

export default danceStyleOptions;
